import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { TransferChallanInModal } from '../model/index';

@Injectable()
export class TransferChallanInService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers({
    //    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

    //     //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    // });
    private transferChellIn = 'api/transferChallanIn';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getTcNoData(query: any): Promise<TransferChallanInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellIn}/getTcNoDataList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getTcInList(query: any): Promise<TransferChallanInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellIn}/getTcInList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     getEditDetails(query: any): Promise<TransferChallanInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });
        const url = query.tc_in_id ? `${this.transferChellIn}/getEditTcInDet` : `${this.transferChellIn}/getEditTcOutDet`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getTransferChallanInModelDetails(query: any): Promise<TransferChallanInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferChellIn}/getTransferChallanInModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     addTransferChellanIn(query: any): Promise<TransferChallanInModal[]> {
        const url = `${this.transferChellIn}/addTransChellIn`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanInModal)
            .catch(this.handleError);
    }

     /*deleteTcOutGridList(rowData: any): Promise<TransferChallanInModal> {
        const url = `${this.transferChellIn}/deleteTcOutGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanInModal)
            .catch(this.handleError);
    }*/

    deleteTcIn(rowData: any): Promise<TransferChallanInModal> {
        const url = `${this.transferChellIn}/deleteTcInList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanInModal)
            .catch(this.handleError);
    }

    /*UpdateTransFerChellanOut(testbilldetail: any): Promise<TransferChallanInModal> {

        const url = `${this.transferChellIn}/updateTCOutData`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TransferChallanInModal)
            .catch(this.handleError);
    }*/

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/tcIn.service.ts